import { useParams } from 'react-router-dom';
import { useProjectId as useProjectIdOld } from 'hooks/store';
import { useEffect } from 'react';

export const useProjectId = () => {
	const params = useParams();

	const projectId = params.projectId || params.id;

	// This ensures projectId is set correct in the store, as old code depends on this state rather than the route params
	const [, setProjectId] = useProjectIdOld();
	useEffect(() => {
		if (projectId) {
			setProjectId(projectId);
		}
	}, [projectId, setProjectId]);

	if (params.id) {
		console.warn(
			'current path is using :id for projectId, which is deprecated. Use :projectId to indicate projectId, not :id'
		);
	}

	if (!projectId) {
		throw new Error(
			'useProjectId must be used in a route that has a :projectId or :id in its path'
		);
	}

	return projectId;
};
